export default __webpack_public_path__ + "static/media/css.0acd01eb.png";